function initProductRecommendationSplides() {
  if (typeof Splide === 'undefined') return;

  var elements = document.querySelectorAll('.js-product-recommendation-splide');
  elements.forEach(function (el) {
    if (el.classList.contains('is-initialized')) return;

    var count = el.querySelectorAll('.product-recommendation__item').length;
    var perPageDesktop = Math.min(count, 4);

    var mobileGap = '10px';
    var mobilePerView = 2;
    var mobileSlideWidth = 'calc((100% - ' + mobileGap + ')/' + mobilePerView + ')';

    var slider = new Splide(el, {
      type: 'slide',
      perPage: perPageDesktop,
      perMove: 1,
      gap: '16px',
      pagination: false,
      arrows: false,
      drag: false,
      breakpoints: {
        991: {
          perPage: mobilePerView,
          perMove: 1,
          gap: mobileGap,
          fixedWidth: mobileSlideWidth,
          drag: true,
          arrows: false,
          padding: { left: '16px', right: '16px' }
        }
      }
    });

    var prevBtn = el.querySelector('.product-recommendation__arrows .product-recommendation__arrow-btn--prev');
    var nextBtn = el.querySelector('.product-recommendation__arrows .product-recommendation__arrow-btn--next');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (!prevBtn.classList.contains('is-disabled')) {
          slider.go('<');
        }
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!nextBtn.classList.contains('is-disabled')) {
          slider.go('>');
        }
      });
    }

    var bar = el.querySelector('.js-product-recommendation-progress-bar');

    function syncControls() {
      var end = slider.Components.Controller.getEnd();
      if (!isFinite(end) || end < 0) end = 0;
      var index = Math.min(Math.max(slider.index, 0), end);

      if (bar) {
        var perView = window.innerWidth <= 991 ? mobilePerView : perPageDesktop;
        var initialRatio = count > 0 ? Math.min(perView / count, 1) : 1;
        var remainingRatio = 1 - initialRatio;
        var progress = initialRatio + (end > 0 ? (index / end) * remainingRatio : 0);
        bar.style.width = String(Math.min(Math.max(progress * 100, 0), 100)) + '%';
      }

      var isPrevDisabled = index <= 0;
      var isNextDisabled = index >= end;

      if (prevBtn) {
        prevBtn.disabled = false;
        prevBtn.classList.toggle('is-disabled', isPrevDisabled);
        prevBtn.setAttribute('aria-disabled', isPrevDisabled ? 'true' : 'false');
      }

      if (nextBtn) {
        nextBtn.disabled = false;
        nextBtn.classList.toggle('is-disabled', isNextDisabled);
        nextBtn.setAttribute('aria-disabled', isNextDisabled ? 'true' : 'false');
      }
    }

    slider.on('mounted move moved updated refresh resized scrolled', syncControls);
    slider.mount();
    el.classList.add('is-initialized');
  });
}

function initProductRecommendations() {
  var recommendationsElements = document.querySelectorAll('.js-product-recommendations[data-url]');

  recommendationsElements.forEach(function (element) {
    var url = element.dataset.url;
    if (!url) return;

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var responseDoc = parser.parseFromString(html, 'text/html');
        var newRecommendations = responseDoc.querySelector('.js-product-recommendations');

        if (newRecommendations && newRecommendations.querySelector('.product-recommendation__item')) {
          element.innerHTML = newRecommendations.innerHTML;
          element.style.display = '';

          // Re-initialize section Splide slider for mobile view
          initProductRecommendationSplides();

          // Re-initialize product card image sliders
          if (typeof initProductCardSplides === 'function') {
            initProductCardSplides(element);
          }
        } else {
          element.innerHTML = '';
          element.style.display = 'none';
        }
      })
      .catch(function (error) {
        console.error('Error fetching product recommendations:', error);
      });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initProductRecommendations();
  initProductRecommendationSplides();
});

window.addEventListener('load', function () {
  initProductRecommendations();
  initProductRecommendationSplides();
});

if ('MutationObserver' in window) {
  var pending = false;
  new MutationObserver(function (mutations) {
    if (pending) return;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1) {
          if (node.matches('.js-product-recommendation-splide') || node.querySelector('.js-product-recommendation-splide')) {
            pending = true;
            requestAnimationFrame(function () {
              pending = false;
              initProductRecommendationSplides();
            });
            return;
          }
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}

// Shopify Theme Editor support
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('js-product-recommendations')) {
      initProductRecommendations();
      initProductRecommendationSplides();
    }
  });
}
